import { createAuthInstance } from './general';
import config from '@/config/api.config';

const infoUrl = config.identity;

const getInfo = async () => {
  return createAuthInstance(infoUrl).get('me/info');
};

const getAccounts = async () => {
  return createAuthInstance(infoUrl).get('account');
};

const getTenants = async () => {
  return createAuthInstance(infoUrl).get('tenant');
};

export const authService = {
  getInfo,
  getAccounts,
  getTenants
};
